import {
  GET_API_TOKEN,
  GET_API_TOKEN_ERROR,
  GET_API_TOKEN_SUCCESS,
  ADD_API_TOKEN,
  ADD_API_TOKEN_ERROR,
  ADD_API_TOKEN_SUCCESS,
  MODIFY_API_TOKEN,
  MODIFY_API_TOKEN_ERROR,
  MODIFY_API_TOKEN_SUCCESS,
  DELETE_API_TOKEN,
  DELETE_API_TOKEN_ERROR,
  DELETE_API_TOKEN_SUCCESS,
  MODIFY_SYNDI_CLICK_SETTINGS,
  MODIFY_SYNDI_CLICK_SETTINGS_SUCCESS,
  MODIFY_SYNDI_CLICK_SETTINGS_ERROR,
  GET_SYNDI_CLICK_SETTINGS,
  GET_SYNDI_CLICK_SETTINGS_SUCCESS,
  GET_SYNDI_CLICK_SETTINGS_ERROR,
  GET_SYNDI_CLICK_ADMIN_SETTINGS,
  GET_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS,
  GET_SYNDI_CLICK_ADMIN_SETTINGS_ERROR,
  MODIFY_SYNDI_CLICK_ADMIN_SETTINGS,
  MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS,
  MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_ERROR,
  GET_SYNDI_CLICK_SOURCE_TYPES,
  GET_SYNDI_CLICK_SOURCE_TYPES_SUCCESS,
  GET_SYNDI_CLICK_SOURCE_TYPES_ERROR,
  CREATE_SYNDI_CLICK_SOURCE_TYPE,
  CREATE_SYNDI_CLICK_SOURCE_TYPE_SUCCESS,
  CREATE_SYNDI_CLICK_SOURCE_TYPE_ERROR,
} from "./actionTypes"

export const getApiToken = () => {
  return {
    type: GET_API_TOKEN
  }
}

export const getApiTokenSuccess = api_tokens => {
  return {
    type: GET_API_TOKEN_SUCCESS,
    payload: api_tokens,
  }
}

export const getApiTokenError = error => {
  return {
    type: GET_API_TOKEN_ERROR,
    payload: error,
  }
}


export const modifyApiToken = api_tokens => {
  return {
    type: MODIFY_API_TOKEN,
    payload: api_tokens
  }
}
export const modifyApiTokenSuccess = api_tokens => {
  return {
    type: MODIFY_API_TOKEN_SUCCESS,
    payload: api_tokens
  }
}
export const modifyApiTokenError = error => {
  return {
    type: MODIFY_API_TOKEN_ERROR,
    payload: error
  }
}


export const createApiToken = api_token => {
  return {
    type: ADD_API_TOKEN,
    payload: api_token
  }
}
export const createApiTokenSuccess = api_token => {
  return {
    type: ADD_API_TOKEN_SUCCESS,
    payload: api_token
  }
}
export const createApiTokenError = error => {
  return {
    type: ADD_API_TOKEN_ERROR,
    payload: error
  }
}

export const deleteApiToken = api_token => {
  return {
    type: DELETE_API_TOKEN,
    payload: api_token
  }
}
export const deleteApiTokenSuccess = api_token => {
  return {
    type: DELETE_API_TOKEN_SUCCESS,
    payload: api_token
  }
}
export const deleteApiTokenError = error => {
  return {
    type: DELETE_API_TOKEN_ERROR,
    payload: error
  }
}

export const getSyndiClickSettings = (syndi_click_settings) => {
  return {
    type: GET_SYNDI_CLICK_SETTINGS,
    payload: syndi_click_settings
  }
}

export const getSyndiClickSettingsSuccess = (syndi_click_settings) => {
  return {
    type: GET_SYNDI_CLICK_SETTINGS_SUCCESS,
    payload: syndi_click_settings
  }
}

export const getSyndiClickSettingsError = (error) => {
  return {
    type: GET_SYNDI_CLICK_SETTINGS_ERROR,
    payload: error
  }
}

export const modifySyndiClickSettings = (syndi_click_settings) => {
  return {
    type: MODIFY_SYNDI_CLICK_SETTINGS,
    payload: syndi_click_settings
  }
}

export const modifySyndiClickSettingsSuccess = (syndi_click_settings) => {
  return {
    type: MODIFY_SYNDI_CLICK_SETTINGS_SUCCESS,
    payload: syndi_click_settings
  }
}

export const modifySyndiClickSettingsError = (error) => {
  return {
    type: MODIFY_SYNDI_CLICK_SETTINGS_ERROR,
    payload: error
  }
}

export const getSyndiClickAdminSettings = (syndi_click_settings) => {
  return {
    type: GET_SYNDI_CLICK_ADMIN_SETTINGS,
    payload: syndi_click_settings
  }
}

export const getSyndiClickAdminSettingsSuccess = (syndi_click_settings) => {
  return {
    type: GET_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS,
    payload: syndi_click_settings
  }
}

export const getSyndiClickAdminSettingsError = (error) => {
  return {
    type: GET_SYNDI_CLICK_ADMIN_SETTINGS_ERROR,
    payload: error
  }
}

export const modifySyndiClickAdminSettings = (syndi_click_settings) => {
  return {
    type: MODIFY_SYNDI_CLICK_ADMIN_SETTINGS,
    payload: syndi_click_settings
  }
}

export const modifySyndiClickAdminSettingsSuccess = (syndi_click_settings) => {
  return {
    type: MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS,
    payload: syndi_click_settings
  }
}

export const modifySyndiClickAdminSettingsError = (error) => {
  return {
    type: MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_ERROR,
    payload: error
  }
}

export const getSyndiClickSourceTypes = () => {
  return {
    type: GET_SYNDI_CLICK_SOURCE_TYPES
  }
}

export const getSyndiClickSourceTypesSuccess = (sourceTypes) => {
  return {
    type: GET_SYNDI_CLICK_SOURCE_TYPES_SUCCESS,
    payload: sourceTypes
  }
}

export const getSyndiClickSourceTypesError = (error) => {
  return {
    type: GET_SYNDI_CLICK_SOURCE_TYPES_ERROR,
    payload: error
  }
}

export const createSyndiClickSourceType = (sourceType) => {
  return {
    type: CREATE_SYNDI_CLICK_SOURCE_TYPE,
    payload: sourceType
  }
}

export const createSyndiClickSourceTypeSuccess = (sourceType) => {
  return {
    type: CREATE_SYNDI_CLICK_SOURCE_TYPE_SUCCESS,
    payload: sourceType
  }
}

export const createSyndiClickSourceTypeError = (error) => {
  return {
    type: CREATE_SYNDI_CLICK_SOURCE_TYPE_ERROR,
    payload: error
  }
}